import type { Store } from './store'

type ReadableStore = { getState: () => Store }

let appStore: ReadableStore | undefined

export const registerStore = (store: { getState: () => unknown }): void => {
    appStore = store as unknown as ReadableStore
}

export const getStore = (): ReadableStore | undefined => appStore
